/* tslint:disable */
/**
 * Custom service proxy for StripeController endpoints.
 *
 * StripeController is marked with [ApiExplorerSettings(IgnoreApi = true)],
 * so NSwag does not generate proxies for it. This file must be maintained manually.
 * DO NOT place these classes in service-proxies.ts as they will be overwritten by NSwag.
 */
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { API_BASE_URL } from './service-proxies';

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next('');
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// #region Service Proxy

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * GET /api/Stripe/config
     */
    getConfig(): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/config';

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Accept': 'application/json'
            })
        };

        return this.http.request('get', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/get-subscription-detail
     */
    getSubscriptionDetail(input: UpdateSubscriptionResponse | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/get-subscription-detail';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/get-customer-detail
     */
    getCustomerDetail(): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/get-customer-detail';

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/create-customer
     * Controller builds the customer from ABpSession — no body required.
     */
    createCustomer(): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/create-customer';

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/change-billing-owner
     */
    changeBillingOwner(selectedUserId: number): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/change-billing-owner';

        const content_ = JSON.stringify(selectedUserId);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/get-customer
     */
    getCustomer(input: GetCustomerRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/get-customer';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/create-subscription
     */
    createSubscription(input: CreateSubscriptionInputDto | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/create-subscription';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/start-subscription
     */
    startSubscription(input: CreateSubscriptionRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/start-subscription';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/retry-invoice
     */
    retryInvoice(input: RetryInvoiceRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/retry-invoice';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/retrieve-subscription-information
     */
    retrieveSubscriptionInformation(input: RetrieveSubscriptionInformationRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/retrieve-subscription-information';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/retrieve-upcoming-invoice
     */
    retrieveUpcomingInvoice(input: RetrieveUpcomingInvoiceRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/retrieve-upcoming-invoice';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/cancel-subscription
     */
    cancelSubscription(input: CancelSubscriptionRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/cancel-subscription';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/cancel-subscription-at-period-end
     */
    cancelSubscriptionAtPeriodEnd(input: CancelSubscriptionRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/cancel-subscription-at-period-end';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/reactivate-subscription
     */
    reactivateSubscription(input: CancelSubscriptionRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/reactivate-subscription';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/update-subscription
     */
    updateSubscription(input: UpdateSubscriptionInputDto | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/update-subscription';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/get-upcoming-invoice
     */
    getUpcomingInvoice(input: UpComingInvoiceRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/get-upcoming-invoice';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/Create-Payment-intent
     */
    createPaymentIntent(amount: number, customerId: string): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/Create-Payment-intent';
        url_ += '?amount=' + encodeURIComponent('' + amount);
        url_ += '&CID=' + encodeURIComponent('' + customerId);

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/Create-Payment-Method
     * Attaches an existing Stripe.js-created payment method to a customer.
     */
    createPaymentMethod(input: AttachCustomerPaymentMethodRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/Create-Payment-Method';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/update-billing-details
     */
    updateBillingDetails(input: LocalBillingDetailInput | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/update-billing-details';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * POST /api/Stripe/retrieve-customer-payment-method
     */
    retrieveCustomerPaymentMethod(input: RetrieveCustomerPaymentMethodRequest | null | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/retrieve-customer-payment-method';

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * GET /api/Stripe/stripe-products
     */
    getProducts(): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/stripe-products';

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Accept': 'application/json'
            })
        };

        return this.http.request('get', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }

    /**
     * GET /api/Stripe/stripe-prices
     */
    getPrices(): Observable<any> {
        let url_ = this.baseUrl + '/api/Stripe/stripe-prices';

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Accept': 'application/json'
            })
        };

        return this.http.request('get', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJsonResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonResponse(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else {
                return <Observable<any>><any>_observableThrow(response_);
            }
        }));
    }


    /**
     * Shared response processor - parses JSON from blob response.
     */
    private processJsonResponse(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result: any = null;
                let resultData = _responseText === '' ? null : JSON.parse(_responseText);
                result = resultData;
                return _observableOf(result);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableThrow('An unexpected server error occurred.');
            }));
        }
        return _observableOf<any>(<any>null);
    }
}

// #endregion

// #region DTOs

export class ConfigResponse {
    publishableKey: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class SubscriptionResponse {
    subscriptionId: string | undefined;
    productId: string | undefined;
    planName: string | undefined;
    currency: string | undefined;
    priceId: string | undefined;
    amount: number | undefined;
    quantity: number | undefined;
    subscriptionEndDate: string | undefined;
    subscriptionStartDate: string | undefined;
    cardLast4: string | undefined;
    cardBrand: string | undefined;
    unit: string | undefined;
    noOfUsers: number | undefined;
    status: string | undefined;
    created: string | undefined;
    cancelAtPeriodEnd: boolean | undefined;
    freeSeats: number | undefined;
    couponCode: string | undefined;
    discountAmount: number | undefined;
    billingType: string | undefined;
    nextInvoiceDate: string | undefined;
    nextInvoiceAmount: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class SubscriptionDetailsOutput {
    subscriptionType: number | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    numberOfUsers: number | undefined;
    usedSeatsCount: number | undefined;
    freeSeats: number | undefined;
    costPerUser: number | undefined;
    amount: number | undefined;
    status: string | undefined;
    productName: string | undefined;
    subscriptionId: string | undefined;
    couponId: number | undefined;
    coupon: string | undefined;
    trialEnd: string | undefined;
    nextInvoiceDate: string | undefined;
    nextInvoiceAmount: number | undefined;
    cancelAtPeriodEnd: boolean | undefined;
    cardBrand: string | undefined;
    cardLast4: string | undefined;
    priceId: string | undefined;
    productId: string | undefined;
    billingType: string | undefined;
    discountAmount: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class UpdateSubscriptionResponse {
    subscription: any | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class CustomerResponse {
    name: string | undefined;
    phone: string | undefined;
    address: any | undefined;
    email: string | undefined;
    currency: string | undefined;
    customerId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class GetCustomerRequest {
    customerid: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class CreatePaymentMethodRequest {
    paymentMethodId: string | undefined;
    customerId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class RetrieveUpcomingInvoiceRequest {
    customerId: string | undefined;
    subscriptionId: string | undefined;
    newPriceId: string | undefined;
    quantity: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class UpdateSubscriptionRequest {
    subscriptionId: string | undefined;
    newPriceId: string | undefined;
    quantity: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class UpdateSubscriptionInputDto {
    subscriptionId: string | undefined;
    quantity: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class CancelSubscriptionRequest {
    subscriptionId: string | undefined;
    selectedReason: string | undefined;
    optionalText: string | undefined;
    mrrAtCancellation: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class CreateSubscriptionRequest {
    paymentMethodId: string | undefined;
    customerId: string | undefined;
    priceId: string | undefined;
    quantity: number | undefined;
    localBillingDetail: LocalBillingDetailInput | undefined;
    coupon: string | undefined;
    discountAmount: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class CreateSubscriptionInputDto {
    type: number | undefined;
    quantity: number | undefined;
    coupon: string | undefined;
    couponId: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class CreateCustomerRequest {
    email: string | undefined;
    name: string | undefined;
    phone: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class LocalBillingDetail {
    name: string | undefined;
    cardNo: string | undefined;
    year: number | undefined;
    month: number | undefined;
    cvv: number | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    state: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    noOfUsers: number | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
    discountAmount: number | undefined;
    isDiscountApplied: boolean | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class LocalBillingDetailInput extends LocalBillingDetail {
    subscriptionId: string | undefined;
    type: number | undefined;
    couponId: number | undefined;
    coupon: string | undefined;
    freeSeats: number | undefined;
    costPerUser: number | undefined;
    customerId: string | undefined;
    paymentMethodId: string | undefined;

    constructor(data?: any) {
        super(data);
    }
}

export class CustomerDetailResponse {
    customer: CustomerResponse | undefined;
    subscription: SubscriptionResponse | undefined;
    localBillingDetail: LocalBillingDetail | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    isOwner: boolean | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class ProductDetail {
    productId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    priceId: string | undefined;
    price: number | undefined;
    currency: string | undefined;
    unit: string | undefined;
    type: string | undefined;
    isSelected: boolean | undefined;
    noOfUsers: number | undefined;
    interval: string | undefined;
    intervalCount: number | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class RetryInvoiceRequest {
    customerId: string | undefined;
    paymentMethodId: string | undefined;
    invoiceId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class RetrieveSubscriptionInformationRequest {
    subscriptionId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class RetrieveCustomerPaymentMethodRequest {
    paymentMethodId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class AttachCustomerPaymentMethodRequest {
    customerId: string | undefined;
    paymentMethodId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

export class UpComingInvoiceRequest {
    subscriptionId: string | undefined;
    newPriceId: string | undefined;
    quantity: number | undefined;
    customerId: string | undefined;

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

// #endregion
